import type { Card } from '../../types';

/** §14 worked card (ADR-0015 §17 mapping). Even faces hit the enemy 2, odd
 * faces hit self 1. */
export const ROULETTE_STRIKE: Card = {
  id: 'roulette-strike',
  name: 'Roulette Strike',
  type: 'recursive',
  rarity: 'rare',
  size: { w: 2, h: 1 },
  cost: [{ kind: 'min', value: 4 }],
  effects: [
    {
      kind: 'rollFresh',
      count: 2,
      perFace: [
        {
          facePredicate: { kind: 'parity', value: 'even' },
          effects: [{ kind: 'damage', amount: 2, target: 'opponent' }],
        },
        {
          facePredicate: { kind: 'parity', value: 'odd' },
          effects: [{ kind: 'damage', amount: 1, target: 'self' }],
        },
      ],
    },
  ],
};
